/**
 * GLightbox utils
 */
import GLightbox from 'glightbox';
import { consentIsGiven, techID } from './_consent';

const currentClass = 'current';
const consentClass = 'glightbox-consent';

function gslideMedia(slide): HTMLElement {
  return slide.slideNode.querySelector('.gslide-media') as HTMLElement;
}

/**
 * Adjust GLightbox HTML and styles when youku iframe is loaded
 * @param lightbox: the containing GLightbox
 */
export function adjustYoukuDOM(lightbox: GLightbox) {
  lightbox.on('slide_after_load', slide => {
    const slideMedia = gslideMedia(slide);
    const slideIframe = slideMedia.getElementsByTagName('iframe')[0] as HTMLIFrameElement;
    if (slideIframe && slideIframe.classList.contains('youku')) {
      const width = slideMedia.style.width;
      const height = slideMedia.style.height;
      const siblings = slideMedia.parentElement.children;
      for (let i = 0; i < siblings.length; i++) {
        const child = siblings.item(i) as HTMLElement;
        child.style.maxWidth = width;
      }
      slideIframe.width = width;
      slideIframe.height = height;
      slideMedia.classList.add('youkuMedia');
    }
  });
}

/**
 * Force usercentrics overlay in GLigthbox visible
 * @param lightbox: the containing GLightbox
 * @param index: trigger for current slide index (optional)
 */
export function showConsent(lightbox: GLightbox, index: number = null) {
  // Show or hide consent
  function toggleConsent(open, slide = null) {
    hideConsent();
    const activeSlide = slide || lightbox.getActiveSlide();
    const className = slide ? consentClass : currentClass;
    if (open && activeSlide) {
      lightbox.getActiveSlide().classList.add(className);
    }
  }
  // Contains this slide youtube and is current index? ->
  if (index != null) {
    lightbox.on('slide_before_load', slide => {
      const open = !consentIsGiven(techID.youtube) && slide.slideConfig.source === 'youtube' && slide.index == index;
      //const open = slide.slideConfig.source === 'youtube' && slide.index == index; // local debugging code
      if (slide.index == index) {
        toggleConsent(open, slide);
      }
    });
  } else {
    lightbox.on('slide_changed', event => {
      const slide = event.current;
      const open = !consentIsGiven(techID.youtube) && slide.slideConfig.source === 'youtube' && slide.index == lightbox.getActiveSlideIndex();
      //const open = slide.slideConfig.source === 'youtube' && slide.index == lightbox.getActiveSlideIndex(); // local debugging code
      toggleConsent(open);
    });
  }
  // Remove styles on consent given
  window.addEventListener('onUpdateServices', () => {
    if (document.getElementById('glightbox-body')) {
      setTimeout(() => showConsent(lightbox), 100);
    }
  });
  // Add additional consents here...
}

function hideConsent() {
  document.querySelectorAll('.'+consentClass).forEach(element => {
    element.classList.remove(consentClass);
  });
}
